import { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AddButton from "../../components/AddButton/AddButton";
import LabelValueDisplay from "../../components/LabelValue/LabelValueDisplay";
import { getLicenseTypes, upgradeInventoryLicense } from "../../../../../actions/Users/authenticateInventory";
import { getRouterDidsData } from "../../../../../actions/Users/authenticateOpenEdgeService";
import _ from "lodash";
import SectionTitleWithHr from "../../components/SectionTitleWithHR/SectionTitleWithHr";
import { CONFIRM_DIALOG_TITLE } from "../../../../../config";

const ChangeLicense = (props) => {
    const { row, getLicenseTypes, licenseTypes, upgradeInventoryLicense, setConfirmDialog, getRouterDidsData, getRouterDids, selectedRouter, setSelectedRouter,
        selectedLicense, setSelectedLicense, selectedTerm, setSelectedTerm
     } = props;
    const [licenseOptions, setLicenseOptions] = useState<any>([]);
    const [termOptions, setTermOptions] = useState<any>([]);
    const [routerIds, setRouterIds] = useState<any>([]);

    useEffect(() => {
        if (!_.isEmpty(row) && row?.tierAlias && row?.tierValue && row?.termDisplay && row?.termValue) {
            setSelectedLicense({ label: row?.['tierAlias'], value: row?.['tierValue'], licenseTier: row?.['licenseTier'] })
            setSelectedTerm({ label: row?.['termDisplay'], value: row?.['termValue'] })
        }
        getLicenseTypes(row['dpId'], row?.['deviceId'])
        getRouterDidsData(row?.['k4Id'])
    }, [row])

    useEffect(() => {
        if (!_.isEmpty(licenseTypes) && licenseTypes?.data && selectedLicense?.value) {
            const licenseData = _.orderBy(licenseTypes.data, ['tierOrder'], ['asc']);

            const types: any[] = [];
            const termMap: { [key: string]: { label: string; value: string }[] } = {};

            licenseData.forEach(tierType => {
                const type = {
                    label: tierType?.tierAlias,
                    value: tierType?.tierType,
                    licenseTier: tierType?.licenseTier
                };

                types.push(type);

                if (tierType.term && Array.isArray(tierType.term)) {
                    const sortedTerms = _.orderBy(tierType.term, ['termOrder'], ['asc']);
                    termMap[tierType.tierType] = sortedTerms.map(term => ({
                        label: term.termDisplay,
                        value: term.termValue
                    }));
                }
            });

            setLicenseOptions(types);

            const selectedTierTerms = termMap[selectedLicense?.value] || [];
            setTermOptions(selectedTierTerms);

            const isSameLicense = selectedLicense?.value === row?.tierValue;
            const termExists = selectedTierTerms.some(t => t.value === selectedTerm?.value);

            if (!isSameLicense || !termExists) {
                setSelectedTerm(selectedTierTerms[0] || {});
            }
        }
    }, [licenseTypes, selectedLicense]);

    useEffect(() => {
        if (!_.isEmpty(getRouterDids)) {
            const data = getRouterDids?.data;
            const filteredData = data
            ?.filter(({ deviceId }) => deviceId !== row?.['deviceId'])
            ?.map((item) => { return { 'deviceAlias': item?.deviceAlias, 'router_did': item?.deviceId } });
            if(filteredData?.length == 1 && (row['deviceId']?.startsWith('RS') || row['deviceId']?.startsWith('RM'))) {
                setSelectedRouter(filteredData?.[0]);
            }
            setRouterIds(filteredData);
        }
    }, [getRouterDids])

    return (
    <>
      <LabelValueDisplay
        label="Licence"
        isDropdown
        dropdownOptions={licenseOptions?.map(licence => licence.label)}
        value={selectedLicense?.label}
        onChange={(e) => {
          const selected = licenseOptions.find(opt => opt.label === e.target.value);
          setSelectedLicense(selected);
        }}
        placeholder="Choose New Licence"
      />

      <LabelValueDisplay
        label="Term"
        isDropdown
        dropdownOptions={termOptions?.map(term => term.label)}
        value={selectedTerm?.label}
        onChange={(e) => {
          const selected = termOptions?.filter(term => term.label)?.find(opt => opt.label === e.target.value);
          setSelectedTerm(selected);
        }}
        placeholder="Choose License Term"
      />

      {row['licenseTier'] != 'T103' && selectedLicense?.licenseTier === "T103" && (
        <LabelValueDisplay
          label="Select Router"
          isDropdown
          dropdownOptions={routerIds?.map((did) => did?.deviceAlias)}
          value={selectedRouter?.deviceAlias}
          onChange={(e) => {
            const selected = routerIds?.find(opt => opt.deviceAlias === e.target.value);
            setSelectedRouter(selected);
          }}
          placeholder="Choose Router"
        />
      )}

      {row['licenseTier'] != 'T103' && selectedLicense?.licenseTier == 'T103' && routerIds?.length == 0 && <span className="ticket-description-alert">Please configure at least one router to Change License as an Access Point (AP)</span>}
    </>
  );
}

const mapStateToProps = (state) => ({
    licenseTypes: state.authReducer?.getLicenseTypes,
    getRouterDids: state.authReducer?.getRouterDids,
});

export default withRouter(
    connect(mapStateToProps, { getLicenseTypes, upgradeInventoryLicense, getRouterDidsData })(ChangeLicense)
);